import {CloseIcon} from "../Svg";
import React, {useState} from "react";
import {toast} from "react-toastify";

export const VideoInput = ({children, onChange, value, name, onRemove, instructions, formats, ...props}) => {

  const [dragging, setDragging] = useState(false);

  const onVideoSelected = (e) => {
    setDragging(false)
    onChange(e.target.files[0], e.target.name);
  }

  const onRemoveClick = () => {
    onRemove(name);
  }

  return (
    <div className={"VideoInput"}>
      {value ?
        <>
          <img className={"VideoInput__VideoUploaded"}
               src={value}/>
          <div className={"VideoInput__VideoUploaded__Close"} onClick={onRemoveClick}><CloseIcon/></div>
        </>
        : <>
          <div
            className={`VideoInput__Label ${dragging ? "VideoInput__Label--dragover" : ""}`}
            onClick={() => document.querySelector(`input[name="${name}"]`).click()}
            onDragOver={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onDragEnter={() => setDragging(true)}
            onDragLeave={() => setDragging(false)}
            onDrop={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                const file = e.dataTransfer.files[0];
                if (formats && formats.indexOf(file.type) === -1
                  || file.type.indexOf("video/") === -1) {
                  toast.error("Invalid file type");
                } else {
                  onChange(file, name);
                }
              }
            }}
          >
            {instructions
              ? instructions
              : <>
                Drag & drop or <span
                className={"VideoInput__Label--Green"}>Choose a file</span> to upload
              </>}
          </div>
          <input
            type="file"
            name={name}
            accept={formats ? formats : "video/*"}
            onChange={onVideoSelected}
          /></>}

      {children}
    </div>
  )
}